import React, { useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Stack } from '@mui/material';
import { ButtonCustom, ButtonOutLine } from '../ButtonCustom';

type CropImageProps = {
  imageUrl: string;
  onCropComplete: (croppedImage: File) => void;
  onCancel: () => void;
  size: {
    height: number;
    width: number;
  };
};

export const CropImage: React.FC<CropImageProps> = ({
  imageUrl,
  onCropComplete,
  size,
  onCancel
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cropperRef = useRef<any>(null);

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas();
      canvas.toBlob(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blob: any) => {
          if (blob) {
            const file = new File([blob], 'cropped.jpg', { type: 'image/jpeg' });
            onCropComplete(file);
          }
        },
        'image/jpeg',
        1.0 // max quality
      );
    }
  };

  return (
    <Stack gap={2} alignItems={'center'}>
      <Cropper
        src={imageUrl}
        style={{ height: size.height, width: size.width }}
        initialAspectRatio={1}
        guides={true}
        ref={cropperRef}
        viewMode={1}
        dragMode="move"
        background={false}
        responsive={true}
        autoCropArea={1}
        checkOrientation={false}
      />
      <Stack style={{ flexDirection: 'row', gap: '20px' }}>
        <ButtonOutLine label={'Cancel'} style={{ width: 166 }} onClick={onCancel} fullWidth />
        <ButtonCustom label={'Crop Image'} style={{ width: 166 }} onClick={handleCrop} fullWidth />
      </Stack>
    </Stack>
  );
};
